import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=b0c04922&lang=pug"
import script from "./AppLoading.vue?vue&type=script&lang=ts"
export * from "./AppLoading.vue?vue&type=script&lang=ts"
import style0 from "./AppLoading.vue?vue&type=style&index=0&id=b0c04922&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports